/* src/app/shared/components/title-card/section-card.component.scss */
.section-card {
  border-radius: 16px;
  display: flex;
  flex-direction: column;
  height: 300px;
  max-width: 280px;
  width: 280px;
  margin: 0 !important;
  padding: 5px;
  background-color: var(--ion-color-secondary);
  color: var(--ion-color-secondary-contrast);
}
.section-card-header {
  color: var(--ion-color-secondary-contrast);
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 5px;
  padding: 14px 4px 0px;
  height: 130px;
  overflow: hidden;
  flex-shrink: 0;
}
.section-card-logo-wrap {
  flex-shrink: 0;
  width: 84px;
  height: 84px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  overflow: hidden;
}
@media (max-width: 768px) {
  .section-card-logo-wrap {
    width: 84px;
    height: 84px;
    border-radius: 16px;
  }
}
@media (max-width: 480px) {
  .section-card-logo-wrap {
    width: 68px;
    height: 68px;
    border-radius: 12px;
  }
}
.section-card-logo {
  font-size: 60px;
}
@media (max-width: 768px) {
  .section-card-logo {
    font-size: 60px;
  }
}
@media (max-width: 480px) {
  .section-card-logo {
    font-size: 48px;
  }
}
.section-card-nfk-chip {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  margin: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  --background: var(--ion-color-primary);
  background: var(--ion-color-primary);
}
.section-card-nfk-text {
  font-size: 1.4rem;
  font-weight: 700;
  color: var(--ion-color-primary-contrast);
  letter-spacing: 0.05em;
}
@media (max-width: 768px) {
  .section-card-nfk-text {
    font-size: 1.4rem;
  }
}
@media (max-width: 480px) {
  .section-card-nfk-text {
    font-size: 1.15rem;
  }
}
.section-card-header-text {
  color: var(--ion-color-secondary-contrast);
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex: 1;
  min-width: 0;
}
.section-card-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: var(--ion-color-secondary-contrast);
  margin-bottom: 7px;
  white-space: normal;
  word-break: break-word;
}
@media (max-width: 480px) {
  .section-card-title {
    font-size: 1rem;
  }
}
.section-card-description {
  color: var(--ion-color-secondary-contrast);
  font-size: 0.86rem;
  white-space: normal;
  line-height: 1.3;
}
@media (max-width: 480px) {
  .section-card-description {
    font-size: 0.85rem;
  }
}
.section-card-body {
  color: var(--ion-color-secondary-contrast);
  flex: 1;
  padding-left: 1.4em;
  overflow-y: auto;
  min-height: 0;
}
.section-card-subtitle-list {
  color: var(--ion-color-secondary-contrast);
  list-style: none;
  margin: 0;
  padding: 0;
}
.section-card-subtitle-item {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 4px;
  font-size: 0.95rem;
  color: var(--ion-color-secondary-contrast);
}
@media (max-width: 480px) {
  .section-card-subtitle-item {
    font-size: 0.85rem;
    padding: 4px 0;
  }
}
.section-card-subtitle-item:last-child {
  border-bottom: none;
}
.section-card-subtitle-text {
  min-width: 0;
  flex: 1;
  word-break: break-word;
  overflow-wrap: anywhere;
  white-space: normal;
  line-height: 1.4;
}
.section-card-subtitle-icon {
  font-size: 1.4rem;
  flex-shrink: 0;
}
.section-card-footer {
  padding: 8px 14px 8px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.section-card-btn {
  --border-radius: 8px;
  --border-width: 1px;
  --padding-start: 10px;
  --padding-end: 10px;
  --padding-top: 6px;
  --padding-bottom: 6px;
  margin: 0;
  font-weight: 600;
  font-size: 0.74rem;
  height: 36px;
  flex: 0.7;
}
@media (max-width: 480px) {
  .section-card-btn {
    font-size: 0.82rem;
    --padding-start: 8px;
    --padding-end: 8px;
  }
}
.section-card-footer-icon {
  font-size: 1.5rem;
  color: var(--ion-color-primary, #3880ff);
  transform: rotate(-360deg);
  flex-shrink: 0;
}
@media (max-width: 480px) {
  .section-card-footer-icon {
    font-size: 1.2rem;
  }
}
/*# sourceMappingURL=section-card.component-H63E22XC.css.map */
